<template>
  <section class="section section-components pb-0" id="faq">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <!-- Basic elements -->
          <h2 class="mb-3">
            <span>Faq</span>
          </h2>
          <VueFaqAccordion :items="myItems" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import VueFaqAccordion from "vue-faq-accordion";

export default {
  components: {
    VueFaqAccordion,
  },
  data() {
    return {
      myItems: [
        {
          title: "When will the sale happen?",
          value: "30/10/2021",
        },
        {
          title: "How many pieces are there in the collection?",
          value: "There are 5555 Unique Algorithmically generated Thug Apes.",
        },
        {
          title: "How much will it cost to mint?",
          value:
            "The mint price will be 0.3 SOL for early apes and 0.5 SOL for normal round.",
        },
        {
          title: "Any Roadmap?",
          value: "Please check on roadmap section.",
        },
        {
          title: "Why Solana?",
          value:
            "Because Solana is the future dummy. With gas prices being ridiculously high on Ethereum, we decided the only reasonable choice was Solana with their amazing NFT toolsets and nearly free TX costs .We want to do whatever we can to support Solana as they seem eager to give fantastic tools to artists, and we love that.",
        },
      ],
    };
  },
};
</script>
<style>
.faq-wrapper {
  max-width: 100% !important;
  width: 100%;
}
</style>
